import React from 'react';
import { Modal, Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchResultGrid from '../searchResultGrid/searchResultGrid';
import modalStyle from '../../styles/modalStyle';
import { caseColumnDef } from '../../colDef/caseColumnDef';
import apiClient from '../../axiosClient';
import Case from '../../interfaces/case';
import JWTTokenPayload from '../../interfaces/JWTTokenPayload';
import { apiCallWrapper, decodedJWT, getOwnerType } from '../../utils/commonUtils';
import RoleManagement from '../../security/roleManagement';

interface CaseUpdateModalProps {
    open: boolean;
    onClose: () => void;
    selectedRows: Case[];
}

const FocusedCaseUnassignmentModal: React.FC<CaseUpdateModalProps> = ({ open, onClose, selectedRows }) => {

    const token: JWTTokenPayload|false  = decodedJWT();

    const handleSubmit = async () => {
        const body = selectedRows.map((row: Case) => ({
            client_reference_id: row.client_reference_id,
            client_name: row.client_name
        }));

        const response = await apiCallWrapper(() => apiClient.post('api/v1/case/focused_case_deallocation', body));

        if (response && response.status === 200) {
            const { message, updated_count } = response.data;
            alert(`${message}\nUpdated Count: ${updated_count}`);
            window.location.reload();
        } else if (response) {
            alert("Focused Case De-allocation failed");
        }
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography id="modal-title" variant="h6">
                        Focused Case Unassignment
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                {RoleManagement.isAgency(getOwnerType(token)) && (
                    <Box>
                        <Typography variant="subtitle1" color="error">
                            Cases focused by the client or system will be skipped during updates.
                        </Typography>
                    </Box>   
                )}
                <Box mt={3}>
                    <Typography variant="subtitle1">Selected Rows:</Typography>
                    <SearchResultGrid
                        getRowId={(row) => row.case_id}
                        results={selectedRows}
                        onSelectRow={() => { }}
                        columns={caseColumnDef}
                        isRowSelectionAllowed={false}
                    />
                </Box>

                <Box mt={3} textAlign="right">
                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default FocusedCaseUnassignmentModal;
